import useSharedStyles from '../shared.styles'

const useStyles = {
  intro: (isMobile: boolean) => ({
    ...useSharedStyles.intro(isMobile),
    flex: 1,
    gap: 5,
    alignItems: 'center',
    paddingBottom: isMobile ? 0 : 3,
  }),
  screen: (isMobile: boolean) => ({
    ...useSharedStyles.screen(isMobile),
    paddingTop: isMobile ? 7.25 : 5,
  }),
  title: {
    maxWidth: 358,
    textAlign: 'center',
  },
  submitContainer: () => ({
    ...useSharedStyles.submitContainer(),
  }),
}

export default useStyles
